// Résout l'équipe cabinet effective d'un client pour une année donnée :
// une surcharge (client.equipeAnnees, une par année) prime rôle par rôle sur
// les valeurs par défaut du client — un rôle non renseigné dans la
// surcharge retombe sur le défaut, même pour une année par ailleurs
// surchargée. Absence totale de surcharge pour l'année = comportement
// historique inchangé (valeurs par défaut du client).
const ROLES = [
  ["email_expertComptable", "id_expertComptable"],
  ["email_collaborateur", "id_collaborateur"],
  ["email_collaborateur_niv2", "id_collaborateur_niv2"],
  ["email_social", "id_social"],
  ["email_juridique", "id_juridique"],
];

export function resolveEquipeForYear(client, annee) {
  const override = (client?.equipeAnnees || []).find((e) => e.annee === annee);
  const resolved = {};
  ROLES.forEach(([emailKey, idKey]) => {
    resolved[emailKey] = override?.[emailKey] ?? client?.[emailKey] ?? null;
    resolved[idKey] = override?.[idKey] ?? client?.[idKey] ?? null;
  });
  return resolved;
}
